var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1H6.81818C5.85376 1 4.92884 1.34241 4.24688 1.9519C3.56493 2.5614 3.18182 3.38805 3.18182 4.25V6.2H1V8.8H3.18182V14H6.09091V8.8H8.27273L9 6.2H6.09091V4.25C6.09091 4.07761 6.16753 3.91228 6.30392 3.79038C6.44031 3.66848 6.6253 3.6 6.81818 3.6H9V1Z",
    stroke: "#F8B326",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbYellow);
export default __webpack_public_path__ + "static/media/fbYellow.26706f977f0ab053bca50cb8c69f5b92.svg";
export { ForwardRef as ReactComponent };